import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTaskNewPatient = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
});
export default SvgTaskNewPatient;
